module.exports = __webpack_public_path__ + "static/media/bg.bf0b2741.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/lucky-chiken/bg.png
// module id = 909
// module chunks = 7